

import React from "react";
import { CheckCircle } from "lucide-react";

// WhatsApp Leads Data
const whatsappLeadsData = [
  {
    heading: "Draw Students In with WhatsApp Campaigns",
    points: [
      "Run Click-to-WhatsApp ads to start chats with curious students.",
      "Add a WhatsApp widget to nudge students toward courses.",
      "Use QR codes on flyers and sites for quick access.",
      "Share WhatsApp links on social media to reach more learners.",
    ],
    buttonText: "Get Start ",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/edutech/EdTech_2.png",
  },
  {
    heading: "Guide Students to Sign Up with WhatsApp",
    points: [
      "Build trust with a Green Tick verified account.",
      "Keep students in the loop with course updates.",
      "Take payments easily with RazorPay & PayU on WhatsApp.",
      "Simplify sign-ups with automated steps.",
    ],
    // buttonText: "Get Start ",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/edutech/EdTech_3.png",
  },
  {
    heading: "Keep Students Hooked with WhatsApp Updates",
    points: [
      "Send timetable updates to keep them on track.",
      "Share news and alerts with personal notifications.",
      "Invite students to fun extras via WhatsApp.",
      "Deliver study materials right to their phones.",
    ],
    buttonText: "Get Start ",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/edutech/EdTech_4.png",
  },
  {
    heading: "Support Students Fast with WhatsApp",
    points: [
      "Answer FAQs instantly with custom auto-replies.",
      "Handle queries smoothly with multi-agent chats.",
      "Make support easy with quick replies and lists.",
      "Ask for feedback to keep improving.",
    ],
    // buttonText: "Get Start ",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/edutech/EdTech_5.png",
  },
];

const Edutechcycle = () => {
  return (
    <>
      <div className="bg-gradient-to-r from-[#075E54] via-[#0A7262] to-[#0D8970] py-12 px-6 text-center">
        <h1 className="text-4xl font-bold text-white">Power Your EdTech with WhatsApp</h1>
        <div className="w-20 h-1 bg-white my-4 mx-auto rounded-full"></div>
        <p className="text-xl text-white max-w-3xl mx-auto">Unlock WhatsApp’s tools to enroll students, share updates, and support them every step of the way in your EdTech journey.</p>
      </div>

      <div className="max-w-6xl mx-auto px-4 py-20">
        {whatsappLeadsData.map((item, index) => (
          <div key={index} className={`flex flex-col lg:flex-row items-center gap-16 my-20 ${index % 2 === 1 ? "lg:flex-row-reverse" : ""}`}>
            <div className="w-full lg:w-1/2">
              <img src={item.image} alt={item.heading} className="w-full h-auto rounded-lg  hover:scale-105 transition-transform" />
            </div>
            <div className="w-full lg:w-1/2">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">{item.heading}</h2>
              <ul className="space-y-4 text-gray-700">
                {item.points.map((point, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <CheckCircle className="text-[#075E54] w-5 h-5 flex-shrink-0" />
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
              {item.buttonText && (
               <a
               href={item.buttonLink}
               className="mt-6 inline-block bg-[#075E54] text-white py-3 px-6 rounded-lg hover:bg-[#064d40] transition-colors"
             >
               {item.buttonText}
             </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default Edutechcycle;